<template>
    <div>
        <button
            class="redesign-toggle-btn"
            @click="toggle"
            :class="buttonClasses"
            :style="buttonStyles"
        >
            {{ isActive ? onLabel : offLabel }}
        </button>
    </div>
</template>


<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
    onLabel: {
        type: String,
        default: 'on',
    },
    offLabel: {
        type: String,
        default: 'off',
    },
    type: {
        type: String,
        default: 'default'
    },
    borderRadius: {
        type: String,
        default: '16px',
    },
    size: {
        type: String,
        default: 'xs',
        validator(value) {
            return ['xxs', 'xs', 'sm', 'sml', 'md'].includes(value);
        },
    },
    outline: {
        type: Boolean,
        default: false,
    },
    round: {
        type: Boolean,
        default: false,
    },
});

const isActive = ref(false);

const buttonClasses = computed(() => ({
    'rounded': !props.round,
    'p-2': props.size === 'xs',
    'py-1 min-h-6': props.size === 'xxs',
    'py-1.5 min-h-6': props.size === 'xs',
    'py-1 min-h-10 md:min-h-6': props.size === 'sm',
    'py-1 min-h-8': props.size === 'sml',
    'py-1 min-h-12 md:py-2 md:min-h-10': props.size === 'md',

    'border': props.outline && ['xs', 'sm', 'sml'].includes(props.size),
    'border-2': props.outline && props.size === 'md',
    'text-sm font-medium': ['xs', 'sm', 'sml'].includes(props.size),
    'text-primary-actions bg-transparent border-primary-actions': props.outline && !isActive.value,
    'text-white bg-primary-actions': !props.outline && isActive.value,
    'text-secondary-actions bg-transparent': props.outline && isActive.value,
    'text-steel bg-gray-100': !props.outline && !isActive.value,
}));

const buttonStyles = computed(() => ({
    borderRadius: props.borderRadius,
}));

const emit = defineEmits(['toggle']);

const toggle = () => {
    isActive.value = !isActive.value;
    emit('toggle', isActive.value);
};
</script>

<style scoped lang="scss">
.redesign-toggle-btn {
    @apply px-2 uppercase font-medium;
    font-size: 10px;
    transition: all 0.5s;
}
</style>
